export default [
  {
    title: '开关',
    key: 'optStatus',
    width: 82,
    type: 'basic'
  },
  {
    title: '计划名称',
    key: 'adName',
    width: 130,
    type: 'basic',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 98,
    type: 'basic'
  },
  {
    title: '计划组',
    key: 'adGroupName',
    width: 115,
    type: 'basic',
    overflow: true
  },
  {
    title: '游戏',
    key: 'gameName',
    width: 98,
    type: 'basic',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: 120,
    overflow: true,
    type: 'basic'
  },
  {
    title: '日预算',
    key: 'budget',
    width: 162,
    overflow: true,
    type: 'basic'
  },
  {
    title: '出价',
    key: 'bid',
    width: 162,
    type: 'basic'
  },
  {
    title: '投放时间',
    key: 'adLaunchTime',
    width: 88,
    type: 'basic',
    overflow: true
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    type: 'report',
    sortable: 'custom',
    width: 94
  },
  {
    title: '实际消耗',
    key: 'amount',
    type: 'report',
    sortable: 'custom',
    width: 94
  },
  {
    title: '曝光量',
    key: 'pv',
    type: 'report',
    sortable: 'custom',
    width: 88
  },
  {
    title: '采集点击数',
    key: 'collectClickNum',
    type: 'report',
    width: 82
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'report',
    sortable: 'custom',
    width: 82
  },
  {
    title: '激活数',
    key: 'downNum',
    type: 'report',
    sortable: 'custom',
    width: 82
  },
  {
    title: '注册数',
    key: 'newUserNum',
    type: 'report',
    sortable: 'custom',
    width: 82
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    type: 'report',
    sortable: 'custom',
    width: 82
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    type: 'report',
    sortable: 'custom',
    width: 106
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    sortable: 'custom',
    width: 94
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    type: 'report',
    sortable: 'custom',
    width: 94
  },
  {
    title: '激活转化率',
    key: 'activeRate',
    type: 'report',
    width: 81
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    type: 'report',
    width: 70
  },
  {
    title: '新增付费创角数',
    key: 'payRoleUserNum',
    type: 'report',
    sortable: 'custom',
    width: 132
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    type: 'report',
    sortable: 'custom',
    width: 132
  },
  {
    title: '当日新增付费设备',
    key: 'payActiveDeviceNum',
    type: 'report',
    sortable: 'custom',
    width: 141
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    type: 'report',
    sortable: 'custom',
    width: 118
  },
  {
    title: '新设备付费率',
    key: 'payActiveDeviceNumRate',
    type: 'report',
    sortable: 'custom',
    width: 118
  },
  {
    title: '新设备充值金额',
    key: 'newDeviceMoney',
    type: 'report',
    sortable: 'custom',
    width: 132
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    type: 'report',
    sortable: 'custom',
    width: 132
  },
  {
    title: '激活总流水',
    key: 'sumMoney',
    type: 'report',
    sortable: 'custom',
    width: 118
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    type: 'report',
    sortable: 'custom',
    width: 118
  },
  {
    title: '新设备回款率',
    key: 'newDeviceRate',
    type: 'report',
    sortable: 'custom',
    width: 118
  },
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    type: 'other',
    width: 70
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    type: 'other',
    width: 72
  },
  {
    title: '激活1日LTV',
    key: 'oneDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活3日LTV',
    key: 'threeDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活7日LTV',
    key: 'sevenDayLtv',
    type: 'other',
    width: 89
  },
  {
    title: '激活30日LTV',
    key: 'thirtyDayLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角次留',
    key: 'twoDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角3留',
    key: 'threeDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角4留',
    key: 'fourDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角5留',
    key: 'fiveDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角6留',
    key: 'sixDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角7留',
    key: 'sevenDayCreateRetain',
    type: 'other',
    width: 70
  },
  {
    title: '创角10留',
    key: 'tenDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角15留',
    key: 'fifteenDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角30留',
    key: 'thirtyDayCreateRetain',
    type: 'other',
    width: 72
  },
  {
    title: '创角1日LTV',
    key: 'oneDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角2日LTV',
    key: 'twoDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角3日LTV',
    key: 'threeDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角4日LTV',
    key: 'fourDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角5日LTV',
    key: 'fiveDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角6日LTV',
    key: 'sixDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角7日LTV',
    key: 'sevenDayCreateLtv',
    type: 'other',
    width: 89
  },
  {
    title: '创角10日LTV',
    key: 'tenDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角15日LTV',
    key: 'fifteenDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '创角30日LTV',
    key: 'thirtyDayCreateLtv',
    type: 'other',
    width: 95
  },
  {
    title: '计划ID',
    key: 'planId',
    width: 134
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 134
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 72,
    overflow: true
  }
]
